import { Chip, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import React from 'react';
import { withStyles } from 'tss-react/mui';

const styles = (theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  pill: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 400,
    borderWidth: 1,
    borderStyle: 'solid',
    height: 24,
    '& .MuiChip-label': {
      padding: '0 10px'
    }
  },
  // Status-specific colors
  unsubmittedPill: {
    backgroundColor: 'transparent',
    color: '#E0E0E0',
    borderColor: '#E0E0E0',
  },
  inReviewPill: {
    backgroundColor: 'transparent',
    color: '#2F80ED',
    borderColor: '#2F80ED',
  },
  savedPill: {
    backgroundColor: 'transparent',
    color: '#2F80ED',
    borderColor: '#2F80ED',
  },
  needsAttentionPill: {
    backgroundColor: 'transparent',
    color: '#C62828',
    borderColor: '#C62828',
  },
  approvedPill: {
    backgroundColor: 'transparent',
    color: '#43A047',
    borderColor: '#43A047',
  },  
  previouslyApprovedPill: {
    backgroundColor: 'transparent',
    color: '#43A047',
    borderColor: '#43A047',
  }
});

type VcmUnitStatus = 'unsubmitted' | 'in_review' | 'needs_attention' | 'approved' | 'previously_approved' | 'saved';

interface StatusConfig {
  label: string;
  colorClass: keyof ReturnType<typeof styles>;
}

const STATUS_CONFIG: Record<VcmUnitStatus, StatusConfig> = {
  unsubmitted: {
    label: 'Unsubmitted',
    colorClass: 'unsubmittedPill',
  },
  in_review: {
    label: 'In Review',
    colorClass: 'inReviewPill',
  },
   saved: {
    label: 'Saved',
    colorClass: 'savedPill',
  },
  needs_attention: {
    label: 'Needs Attention',
    colorClass: 'needsAttentionPill',
  },
  approved: {
    label: 'Approved',
    colorClass: 'approvedPill',
  },
  previously_approved: {
    label: 'Previously approved',
    colorClass: 'previouslyApprovedPill',
  }
};

interface VcmUnitStatusPillProps {
  classes: Record<keyof ReturnType<typeof styles>, string>;
  status: VcmUnitStatus | string;
}

const VcmUnitStatusPill: React.FC<VcmUnitStatusPillProps> = ({ classes, status }) => {
  const config = STATUS_CONFIG[status as VcmUnitStatus];
    
    if (!config) {
      // Fallback for unknown status
      return (
        <Typography fontSize={13} fontWeight={400} color='primary'>
          {status}
        </Typography>
      );
    }

  const pillClassName = `${classes.pill} ${classes[config.colorClass]}`;

  return (
    <div className={classes.container}>
      <Chip
        label={config.label}
        className={pillClassName}
        size="small"
      />
    </div>
  );
};

export default withStyles(VcmUnitStatusPill, styles);